import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import {  searchCustomer } from "src/apis/customerApi";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";


import { BRDiv } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { defaultPUR1030_R01HeaderDto, PUR1030_R01DetailDto, PUR1030_R01HeaderDto } from "./Dto_PUR1030_R01";
import { usePUR1030_R01Store } from "./Store_PUR1030_R01";
import { AgGridReact } from "ag-grid-react";
import { formatDate } from "src/utils/string/stringUtil";
import { isOrderLocked } from "src/utils/order/orderUtils";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { getEmployeeList } from "src/apis/employeeApi";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";



interface Props {
	editable: boolean
	defaultPUR1030_R01HeaderRow: PUR1030_R01HeaderDto;
}

export const Info_PUR1030_R01 = (props: Props) => {

	const { editable, defaultPUR1030_R01HeaderRow } = props;

	// 
	const { vatTypeList, moneyCdList, compCdList, customCdList, wmsCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();
	const { PUR1030_R01DetailList, deletedPUR1030_R01DetailList,
			editPUR1030_R01, setEditPUR1030_R01,
	} = usePUR1030_R01Store();
	const isLocked = isOrderLocked(editPUR1030_R01?.orderStatus);


	const custInfoHandleFoucsId = 'infoCustInput';
	const empInfoHandleFoucsId = 'infoEmpInput';
	const addressHandleFoucsId = 'addressInput2';

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
				telNo: 'telNo',
				faxNo: 'faxNo',
				moneyCd: 'moneyCd',
				taxEmail: 'email',
				post: 'post',
				address: 'address',
				detailAddress: 'otherAddress',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: editPUR1030_R01?.customCd || '',
				customNm: editPUR1030_R01?.customNm || '',
			}),
		},
		{
			fieldName: 'empNo',
			category: '담당자',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editPUR1030_R01?.empNo || '',
				empNm: editPUR1030_R01?.empNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editPUR1030_R01,
		setEditData: setEditPUR1030_R01,
		defaultData: defaultPUR1030_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR1030_R01'
	});

	// 출고일자 달력 팝업 상태
	const [deliveryPickerVisible, setDeliveryPickerVisible] = useState(false);
	const [deliveryPickerPos, setDeliveryPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	// 매출일자 달력 팝업 상태
	const [salesPickerVisible, setSalesPickerVisible] = useState(false);
	const [salesPickerPos, setSalesPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	// 부가세 입력 포커스 상태 및 표시값 관리
	const [vatAmtInputFocused, setVatAmtInputFocused] = useState(false);
	const [vatAmtInputValue, setVatAmtInputValue] = useState('');
	const [vatAmtManuallyEdited, setVatAmtManuallyEdited] = useState(false);

	const calculateAmtInfo = useCallback((vatTypeInput?: string) => {
		
		const editPUR1030_R01 = usePUR1030_R01Store.getState().editPUR1030_R01 || defaultPUR1030_R01HeaderRow;
		const newVatType = vatTypeInput || editPUR1030_R01?.vatType;

		const newOrderAmt = PUR1030_R01DetailList.reduce((sum, item) => 
			sum + (deletedPUR1030_R01DetailList.includes(item.valueIndex?.toString() || '') ? 0 : item.itemAmt), 0);

		let newVatAmt = editPUR1030_R01?.vatAmt || 0;

		const selectedVatType = vatTypeList.find(vat => vat.minorCd === newVatType);
		
		newVatAmt = Number(newOrderAmt || 0) * Number(selectedVatType?.ref01 || 0) / 100;

		setEditPUR1030_R01({
			...defaultPUR1030_R01HeaderRow,
			...editPUR1030_R01,
			vatType: vatTypeInput || editPUR1030_R01?.vatType,
			orderAmt: newOrderAmt,
			vatAmt: newVatAmt,
			totalAmt: newOrderAmt + newVatAmt
		})
		return newOrderAmt;
	}, [PUR1030_R01DetailList, deletedPUR1030_R01DetailList, editPUR1030_R01?.vatType]);

	useEffect(() => {
		calculateAmtInfo();
	}, [PUR1030_R01DetailList, deletedPUR1030_R01DetailList, editPUR1030_R01?.vatType])

	useEffect(() => {
		// editPUR1030_R01.vatAmt가 바뀌면 표시값도 갱신 (포커스 없을 때만)
		if (!vatAmtInputFocused) {
			setVatAmtInputValue(Number(editPUR1030_R01?.vatAmt || 0).toLocaleString());
		}
	}, [editPUR1030_R01?.vatAmt, vatAmtInputFocused]);

	// 조회 시 수동 편집 상태 초기화
	useEffect(() => {
		// 조회된 데이터가 있고 편집되지 않은 상태라면 수동 편집 상태 리셋
		if (editPUR1030_R01?.purchaseOrderNo && !PUR1030_R01DetailList.some(item => item.inserted || item.isModified)) {
			setVatAmtManuallyEdited(false);
		}

	}, [editPUR1030_R01?.purchaseOrderNo, PUR1030_R01DetailList]);

	const handleDateChange = useCallback((field: keyof PUR1030_R01HeaderDto, value: any) => {
		setEditPUR1030_R01({
			...defaultPUR1030_R01HeaderRow,
			...editPUR1030_R01,
			[field]: value
		});
	}, [editPUR1030_R01]);

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		// 매출액 또는 부가세가 변경될 때 공급총액도 같이 변경
		if (name === 'OrderAmt' || name === 'vatAmt') {
			const OrderAmt = name === 'OrderAmt' ? Number(value) : Number(editPUR1030_R01?.orderAmt ?? 0);
			const vatAmt = name === 'vatAmt' ? Number(value) : Number(editPUR1030_R01?.vatAmt ?? 0);
			
			// 부가세를 수동으로 수정한 경우
			if (name === 'vatAmt') {
				setVatAmtManuallyEdited(true); // 수동 편집 상태로 설정
			}
			
			setEditPUR1030_R01({
				...defaultPUR1030_R01HeaderRow,
				...editPUR1030_R01,
				[name]: Number(value), // 숫자로 변환하여 저장
				totalAmt: OrderAmt + vatAmt
			});
			return;
		}

		// 부가세 구분이 변경될 때 자동 계산
		if (name === 'vatType') {
			calculateAmtInfo(value);
			return;
		}

		setEditPUR1030_R01({
			...defaultPUR1030_R01HeaderRow,
			...editPUR1030_R01,
			[name]: value
		});
	}, [editPUR1030_R01]);



	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">
				
				{/* editPUR1030_R01 : {JSON.stringify(editPUR1030_R01)} <br /> */}

				<InputForm title="전표No" value={editPUR1030_R01?.purchaseOrderNo || ""} 
					editable={false}
					name="purchaseOrderNo" 
					onChange={handleChange} />
				<InputForm 
					title="주문상태" 
					value={editPUR1030_R01?.orderStatus === 'E' ? '입고완료' : editPUR1030_R01?.orderStatus === 'P' ? '입고진행중' : '입고대기'} 
					editable={false}
					name="orderStatus" 
					onChange={() => {}} 
				/>
				<BRDiv />

				<SingleDateForm
					title="발주일자"
					value={editPUR1030_R01?.orderDt ? new Date(editPUR1030_R01.orderDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('orderDt', formatDate(value))}
					editable={!isLocked}
					visible={salesPickerVisible}				setVisible={setSalesPickerVisible}
					onChange={handleChange}
					pickerPos={salesPickerPos}						setPickerPos={setSalesPickerPos}
				/>
				<DropDownForm
					title="사업장"
					name="compCd"
					initLabelLess={true}
					value={editPUR1030_R01?.compCd}
					data={compCdList}
					editable={!isLocked}
					onChange={handleChange}
				/>
				<BRDiv />


				<CodeForm
					label="거래처"
					value={editPUR1030_R01?.customCd || ""}
					custNmValue={editPUR1030_R01?.customNm || ""}
					editable={!isLocked}
					handleFoucsId={custInfoHandleFoucsId}
					name="customCd"
					handleChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>

				<CodeForm
					label="발주자"
					value={editPUR1030_R01?.empNo || ""}
					custNmValue={editPUR1030_R01?.empNm || ""}
					editable={!isLocked}
					handleFoucsId={empInfoHandleFoucsId}
					name="empNo"
					handleChange={getFieldHandlers('empNo').onChange}
					onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
					onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>
				<BRDiv />

				
				<InputForm	title="전화번호" 
						value={editPUR1030_R01?.telNo || ""} 
						editable={!isLocked} 
						name="telNo" 
						onChange={handleChange}
					/>
        
				<InputForm 
					title="e-mail" 
					value={editPUR1030_R01?.email || ""} 
					editable={!isLocked} 
					name="email" 
					onChange={handleChange}
				/>
				<BRDiv />
				<InputForm	title="팩스번호" 
						value={editPUR1030_R01?.faxNo || ""} 
						editable={!isLocked} 
						name="faxNo" 
						onChange={handleChange}
					/>
				
				<DropDownForm<SysCodeDto> 
						title="기준화폐"
						data={moneyCdList}
						value={editPUR1030_R01?.moneyCd}
						name="moneyCd" 
						editable={!isLocked}
						initLabelLess={true}
						onChange={handleChange} />
				<BRDiv />
				
				<DropDownForm<SysCodeDto> 
						title="입고물류센터"
						data={wmsCdList}
						value={editPUR1030_R01?.logicCenter || ""}
						name="logicCenter" 
						editable={!isLocked}
						initLabelLess={true}
						onChange={handleChange} />
        
				<SingleDateForm
					title="입고요청일"
					value={editPUR1030_R01?.dueDt ? new Date(editPUR1030_R01.dueDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('dueDt', formatDate(value))}
					editable={!isLocked}
					visible={deliveryPickerVisible}				setVisible={setDeliveryPickerVisible}
					pickerPos={deliveryPickerPos}				setPickerPos={setDeliveryPickerPos}
				/>
				<BRDiv />
				
				<InputForm	title="발주금액" 
							value={editPUR1030_R01?.orderAmt || 0} 
							editable={false} 
							name="orderAmt" 
							onChange={handleChange} 
							/>
				<DropDownForm
					title="부가세구분" 
					value={editPUR1030_R01?.vatType}
					name="vatType"
					initLabelLess={true}
					data={vatTypeList}
					editable={!isLocked}
					onChange={handleChange} 
				/>
				<BRDiv />
				<InputForm	title="부가세" 
							value={editPUR1030_R01?.vatAmt ?? 0} 
							editable={!isLocked} 
							name="vatAmt" 
							onChange={handleChange}
						/>
		
				<InputForm	title="공급총액" 
							value={editPUR1030_R01?.totalAmt ?? 0} 
							editable={false} 
							name="totalAmt" 
							onChange={handleChange} 
							/>
				<BRDiv />
				
				<InputForm
					title="비고"
					value={editPUR1030_R01?.remark || ""}
					editable={!isLocked}
					name="remark"
					wrapperOption={{
						wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[10px]",
						titleStyle: "w-[100px] min-w-[100px] text-left",
						inputStyle: "w-full min-w-full"
					}}
					onChange={handleChange}
				/>
				
		</div>
	)
}